import React, { useEffect } from 'react';
import V2Nav from './V2Nav';
import V2Footer from './V2Footer';
import '../v2.css';

const V2Layout = ({ children, title }) => {
  useEffect(() => {
    if (title) document.title = title;
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div className="v2-root min-h-screen">
      <V2Nav />
      <main>{children}</main>
      <V2Footer />
    </div>
  );
};

export default V2Layout;
